import React from 'react'
import { useTranslation } from 'react-i18next'
import { DisconnectOutlined } from '@ant-design/icons'

import { useAuth } from '@/middlewares/auth/auth-context'
import { StripeServices } from '@/middlewares/services'
import Confirm from '../common/Confirm'
import TranslationNS from '@/utils/Constants/TranslationNS'
import SButton from '../common/SButton'

import './Stripe.scss'

const stripeIntegration = import.meta.env.VITE_STRIPE_INTEGRATION

const Stripe = ({ user }) => {
    const { t } = useTranslation(TranslationNS.STRIPE)

    const authContext = useAuth()

    const handleDeleteOnConfirm = () => {
        StripeServices.DisconnectStripeAccount(authContext.token).then((res) => {
            location.reload()
        })
    }

    return (
        <>
            {user.organisation_settings?.stripe?.account_id ? (
                <Confirm
                    onConfirm={handleDeleteOnConfirm}
                    title={`${t('Confirm disconnect stripe')} - ${authContext.user.organisation}`}
                    message={t(
                        'Are you sure you want to disconnect your stripe ? Paid registrations would no longer be processed.',
                    )}
                >
                    <SButton
                        value={t('Disconnect stripe')}
                        type="danger"
                        Icon={DisconnectOutlined}
                        iconStyle={{ fontSize: '1em' }}
                        style={{ marginBottom: '20px' }}
                    />
                </Confirm>
            ) : (
                <a href={stripeIntegration} style={{ width: 'fit-content' }}>
                    <SButton
                        value={t('Connect stripe')}
                        gradient
                        gradientVariant={2}
                        style={{ paddingInline: '2.5em' }}
                    />
                </a>
            )}
        </>
    )
}

export default Stripe
